import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';

import type { ResourcesByType } from '@toolproof-core/lib/_contract/resources';

import type { CosmosDataModel } from '@/adapters/core/_contract/config';

export function buildCosmosData(resourcesByType: ResourcesByType<ResourceTypeHandle>): CosmosDataModel {
    return { resourcesByType };
}
